import { render } from "./PreDeliveryIndex.vue?vue&type=template&id=e33dc7be"
import script from "./PreDeliveryIndex.vue?vue&type=script&lang=js"
export * from "./PreDeliveryIndex.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__